import React from 'react';

const EmojiIcon = () => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
       width="22"
       height="22"
       viewBox="0 0 22 22" >
    <g>
      <path d="M11,21C5.5,21,1,16.5,1,11S5.5,1,11,1s10,4.5,10,10S16.5,21,11,21z M11,2.8c-4.5,0-8.2,3.7-8.2,8.2s3.7,8.2,8.2,8.2
        s8.2-3.7,8.2-8.2S15.5,2.8,11,2.8z"/>
      <g>
        <circle cx="8.4" cy="8.4" r="1.4"/>
        <circle cx="13.6" cy="8.4" r="1.4"/>
      </g>
      <path d="M15.9,13c-0.4-0.4-0.9-0.4-1.3,0l0,0l0,0c-1,1-2.3,1.5-3.6,1.5S8.4,14,7.4,13l0,0l0,0c-0.4-0.4-0.9-0.4-1.3,0
        c-0.4,0.4-0.4,0.9,0,1.3c1.4,1.4,3.1,2,4.9,2l0,0l0,0c1.8,0,3.6-0.7,4.9-2C16.3,13.9,16.3,13.4,15.9,13z"/>
    </g>
  </svg>
);

export default EmojiIcon;
